import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private activeTermSource = new BehaviorSubject<string>('Market Benchmarks');
  activeTerm$ = this.activeTermSource.asObservable();

  setActiveTerm(term: string) {
    this.activeTermSource.next(term);
  }
}